module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/pod.ba954328.svg";